import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginSuccess } from '../../redux/reducers/Auth';

const AuthRedirect = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (token) {
            dispatch(loginSuccess({ token }));
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        navigate('/');
    }, [dispatch, navigate]);
};
export default AuthRedirect;
